import { Action, initialState, State } from "store/store";

export const rehydrateFromLMS = (
  state: State = initialState,
  { data }: Action
): State => {
  const { interactionsSeen } = data as any;

  return {
    ...state,
    ...interactionsSeen,
  } as any;
};
